// extracted by mini-css-extract-plugin
export default {"badge":"PlaceholderDate_badge__CK-gg","badgeGray":"PlaceholderDate_badgeGray__ASfyY","badgePurple":"PlaceholderDate_badgePurple__BWTEM"};